import { ONG_CARD_STATES } from 'solidarity.module/common/domain/constants.solidarity';

class OngsCardController {
  constructor(EventEmitter, $log, $scope) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.log = $log;
    this.scope = $scope;

    this._setWatchAmount();
  }

  $onInit() {
    this.amount = this.ong.contribution.amount;
  }

  _setWatchAmount() {
    this.scope.$watch(() => this.ong.contribution.amount, () => {
      this.amount = this.ong.contribution.amount;
    });
  }

  // TODO: ongCardButtons component
  isInitialState() {
    return this.ong.cardState === ONG_CARD_STATES.INITIAL;
  }

  isContributionState() {
    return this.ong.cardState === ONG_CARD_STATES.CONTRIBUTION;
  }

  isAddState() {
    return this.ong.cardState === ONG_CARD_STATES.ADD;
  }

  isEditState() {
    return this.ong.cardState === ONG_CARD_STATES.EDIT;
  }

  goAddDonation() {
    this.ong.cardState = ONG_CARD_STATES.ADD;
  }

  goEditDonation() {
    this.ong.cardState = ONG_CARD_STATES.EDIT;
  }

  cancelAddDonation() {
    this.ong.cardState = ONG_CARD_STATES.INITIAL;
    this.amount = this.ong.contribution.amount;
  }

  cancelEditDonation() {
    this.ong.cardState = ONG_CARD_STATES.CONTRIBUTION;
    this.amount = this.ong.contribution.amount;
  }

  editCardState($event) {
    this.ong.cardState = $event.cardState;
  }

  editAmount($event) {
    this.amount = $event.amount;
  }

  addContribution() {
    if (!this.amount) {
      this.amount = this.ong.minContribution;
    }

    this.onCreate(this.EventEmitter({ ong: this.ong, amount: this.amount}));
  }

  updateContribution() {
    this.onEdit(this.EventEmitter({ ong: this.ong, amount: this.amount }));
  }

  cancelContribution() {
    this.onCancel(this.EventEmitter({ ong : this.ong}));
  }
}

export default OngsCardController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCard.controller.js